import { useMemo } from 'react';
import { locales, getLocale, defaultLocale } from '../locales';

export const useLocalization = () => {
  const currentLocale = getLocale();

  const t = useMemo(() => {
    const selectedLocale = locales[currentLocale] || locales[defaultLocale];

    return (key, params = {}) => {
      // Split key by dots to support nested keys like "months.0"
      const keys = key.split('.');
      let value = selectedLocale;

      for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
          value = value[k];
        } else {
          // Return the key if translation not found
          console.warn(`Translation missing for key: ${key}`);
          return key;
        }
      }

      // Replace parameters in the translation string
      if (typeof value === 'string' && Object.keys(params).length > 0) {
        return value.replace(/\{(\w+)\}/g, (match, paramKey) => {
          return params[paramKey] !== undefined ? params[paramKey] : match;
        });
      }

      return value;
    };
  }, [currentLocale]);

  const formatDate = useMemo(() => {
    return (dateStr, weekday) => {
      try {
        const date = new Date(dateStr + 'T00:00:00');
        const day = date.getDate();
        const month = t(`months.${date.getMonth()}`);
        const year = date.getFullYear();

        // Always use localized weekday from date calculation, ignore API weekday
        const formattedWeekday = t(`weekdays.${date.getDay()}`);

        // Use different format based on locale
        if (currentLocale === 'es') {
          return `${day} de ${month} de ${year} - ${formattedWeekday}`;
        } else {
          return `${month} ${day}, ${year} - ${formattedWeekday}`;
        }
      } catch (error) {
        console.error('Error formatting date:', error);
        return dateStr;
      }
    };
  }, [t]);

  return {
    t,
    locale: currentLocale,
    formatDate,
    isSpanish: currentLocale === 'es',
    isEnglish: currentLocale === 'en'
  };
};